import * as React from "react";
import create from "zustand";
import { useAuthenticatedKnockClient, useNotifications } from "../../hooks";
import { feedProviderKey } from "../../utils";
import { KnockFeedContainer } from "./KnockFeedContainer";
import { KnockI18nProvider } from "../KnockI18nProvider";
var FeedStateContext = /*#__PURE__*/React.createContext(null);
export var KnockFeedProvider = _ref => {
  var {
    apiKey,
    host,
    userId,
    userToken,
    feedId,
    children,
    defaultFeedOptions = {},
    colorMode = "light",
    rootless = false,
    i18n
  } = _ref;
  var knock = useAuthenticatedKnockClient(apiKey, userId, userToken, {
    host
  });
  var feedClient = useNotifications(knock, feedId, defaultFeedOptions);
  var useFeedStore = create(feedClient.store);
  var content = rootless ? children : /*#__PURE__*/React.createElement(KnockFeedContainer, null, children);
  return /*#__PURE__*/React.createElement(FeedStateContext.Provider, {
    key: feedProviderKey(feedId, defaultFeedOptions),
    value: {
      knock,
      feedClient,
      useFeedStore,
      colorMode
    }
  }, /*#__PURE__*/React.createElement(KnockI18nProvider, {
    i18n: i18n
  }, content));
};
export function useKnockFeed() {
  var context = React.useContext(FeedStateContext);

  if (context === undefined) {
    throw new Error("useFeedState must be used within a FeedProvider");
  }

  return context;
}
//# sourceMappingURL=KnockFeedProvider.js.map